export enum ChartTypeEnum {
  Bar = 'bar',
  Doughnut = 'doughnut',
  Pie = 'pie',
  Line = 'line',
}
